/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSuperSelectContent/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaSuperSelectContent({
  children,
  viewPath = "/DesignSystem/TysiaSuperSelect/TysiaSuperSelectContent",
  maxWidth,
  size,
  dock,
  disabled,
  focused,
  invalid,
  from,
  id,
  hovered,
  valid,
  placeholder,
  value,
  onBlur,
  onFocus,
  onChange,
  onSubmit
  
}) {
let dtTysiainputcontentBackgroundcolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.backgroundColor.primary.base'
        })
let dtTysiainputcontentBordercolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.borderColor.primary.base'
        })
let dtTysiainputcontentBordercolorPrimaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.borderColor.primary.disabled'
        })
let dtTysiainputcontentBordercolorPrimaryFocused = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.borderColor.primary.focused'
        })
let dtTysiainputcontentBordercolorPrimaryInvalid = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.borderColor.primary.invalid'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaSuperSelectContent.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-262C2K': dtTysiainputcontentBackgroundcolorPrimaryBase,'--mw-9-262C2K': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--pt-7-262C2K': size === "small" ? "2px" : "5px",'--pb-8-262C2K': size === "small" ? "2px" : "5px",'--bblr-2-262C2K': dock === "left" ? "0px" : "4px",'--btlr-4-262C2K': dock === "left" ? "0px" : "4px",'--bbrr-3-262C2K': dock === "right" ? "0px" : "4px",'--btrr-5-262C2K': dock === "right" ? "0px" : "4px",'--bc-6-262C2K': disabled ? dtTysiainputcontentBordercolorPrimaryDisabled : focused ? dtTysiainputcontentBordercolorPrimaryFocused : invalid ? dtTysiainputcontentBordercolorPrimaryInvalid : dtTysiainputcontentBordercolorPrimaryBase}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 from={from}
 id={id}
 size={size}
 dock={dock}
 focused={focused}
 disabled={disabled}
 hovered={hovered}
 invalid={invalid}
 valid={valid}
 placeholder={placeholder}
 value={value}
 onBlur={onBlur}
 onFocus={onFocus}
 onChange={onChange}
 onSubmit={onSubmit}
>
{children}
</Children>
</div>
</React.Fragment>)
}